import { IMessageItem } from '../interfaces/chat.interfaces';

export const instanceOfMessage = (object: any): object is IMessageItem => {
  return !object.hasOwnProperty('message_pinged');
}
